import { ClassificationListSortField } from "@/graphql/codegen/graphql"

export type ClassificationSortableAccessorKey =
  | "productCategory"
  | "productClass"
  | "productManager"
  | "CreatedOn"
  | "UpdatedOn"

export const accessorKeyToClassificationSortField = new Map<
  ClassificationSortableAccessorKey,
  ClassificationListSortField
>([
  ["productCategory", ClassificationListSortField.Category],
  ["productClass", ClassificationListSortField.Class],
  ["productManager", ClassificationListSortField.ProductManager],
])

export const classificationSortFieldToAccessoryKey = new Map<
  ClassificationListSortField,
  ClassificationSortableAccessorKey
>([
  [ClassificationListSortField.Category, "productCategory"],
  [ClassificationListSortField.Class, "productClass"],
  [ClassificationListSortField.ProductManager, "productManager"],
])
